<template>
  <div class="header-wrapper df fdr jcsb aic w100p">
    <div class="header-inner f1 df aic w100p">
      <img src="../../static/images/cup-wise-logo.svg" class="curp" @click="goTo('/me')">
      <p class="cupwise curp" @click="goTo('/me')"><span>Cup</span>Wise</p>
      <div class="f1 df jcfe aic bar-links">
        <i v-if="$store.getters['AUTH.uid'] && !$store.getters['AUTH.anonUser']" class="icon-coffee icon curp" @click="showCuppingSettings()"></i>
        <a v-else class="login-prompt"><a @click="goTo('/?auth=register')">Login</a> to save scores</a>
        <!-- <p class="logout" @click="logout()">Logout</p> -->
        <!-- <i class="icon-gear icon" @click="showSessionSettings()"></i> -->
      </div>
      </a>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import ShopProduct from '@/components/ShopProduct'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'Header',
  data () {
    return {
      some: 'data'
    }
  },
  props: ['mode'],
  components: {
    ShopProduct
  },
  methods: {
    logout () {
      this.$store.dispatch('AUTH.logout', {})
    },
    showCuppingSettings () {
      this.$store.dispatch('AUTH.showCuppingSettings', true)
    },
    hide () {
      this.$store.dispatch('AUTH.showHeaderShop', false)
    },
    goTo (path) {
      this.$store.dispatch('AUTH.showHeaderShop', false)
      router.push(path)
    },
    showShop (event) {
      event.stopPropagation()
      this.$store.dispatch('AUTH.showHeaderShop', !this.$store.getters['AUTH.showHeaderShop'])
    },
    goToPrevious () {
      router.push('/previous')
    },
    goToLive () {
      router.push('/live')
    },
    goToAccount () {
      let uid = this.$store.getters['AUTH.uid']
      if (uid) {
        router.push('/myaccount')
      } else {
        router.push('/login')
      }
    }
  },
  computed: {

  },
  watch: {
  },
  mounted () {
  },
  directives: {
    ClickOutside
  },
  created () {
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";
  h1, h2, h3, h4, h5, h6, h7, h8 {
    font-weight: 600,
  }
  .header-wrapper {
    background-color: #efeff0;
    height: 40px;
    padding-left: 15px;
    padding-right: 15px;
    z-index: 1;
  }
  .header-inner {
    padding-left: 15px;
    padding-right: 15px;
    height: 100%;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    /*width: calc(100% - 30px);*/
  }
  .bar-links {
    font-size: 14px;
  }
  .shop-dropdown {
    position: absolute;
    top: 145px;
    left: 0;
    width: 100%;
    height: 355px;
    background-color: #1E1F20;
  }
  .shop-dropdown-wrapper {
    max-width: $max-width;
  }
  .red-dot {
    display: inline-block;
    min-height: 15px;
    min-width: 15px;
    border-radius: 6px;
    background-color: red;
    margin-right: 8px;
    padding: 5px;
    font-weight: 600;
  }
  .powered-by {
    font-size: 12px;
    margin-bottom: 10px;
  }
  .taste-together {
    font-size: 14px;
  }
  .inverted-colors {
    .header-inner {
      background-color: #fff;
      /*border-bottom: 1px solid #DBDBDB;*/
      /*background-color: #efeff0;*/
    }
    .cupwise {
      color: #000000;
      font-family: Inter;
      font-size: 16px;
      font-weight: 300;
      letter-spacing: 0;
      line-height: 20px;
      margin-left: 4px;

      span {
        font-weight: 800;
      }
    }
  }

  .icon-gear, .icon-coffee {
    font-size: 22px;
    opacity: 0.75;
  }
  .logout {
    cursor: pointer;
    font-size: 12px;
    margin-left: 20px;
  }
  @media (max-width: 420px) {
    .header-wrapper {
      padding-left: 0;
      padding-right: 0;
      .header-inner {
        border-radius: 0;
      }
    }
  }
  .login-prompt {
    font-size: 12px;
    a {
      color: $color-primary;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Header.vue